import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ChartProvider } from './components/charts';
import { initApiClient } from './lib/api-client';
import { ThemeProvider } from './providers/ThemeProvider';
import { router } from './router';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // Default: 60s for static reference data (segment lists, templates, etc.)
      // Override per-query with staleTime: 5_000 for live dashboard metrics
      staleTime: 60_000,
    },
  },
});

initApiClient();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ChartProvider>
          <RouterProvider router={router} />
        </ChartProvider>
        <Toaster
          richColors
          position="bottom-right"
          duration={4000}
          toastOptions={{
            style: {
              background: 'var(--surface-overlay)',
              border: '1px solid var(--border-subtle)',
              boxShadow: 'var(--shadow-lg)',
              color: 'var(--text-primary)',
              fontSize: '14px',
            },
          }}
        />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
